import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl, baseHeaders } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const syncApi = createApi({
  reducerPath: 'syncApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Sync'],
  endpoints: (builder) => ({
    get: builder.query({
      query: (data) => {
        const params = {}

        if (data.page) {
          params.page = data.page
        }

        if (data.perPage) {
          params.per_page = data.perPage
        }

        if (data.store) {
          params.store = data.store
        }

        if (data.job) {
          params.job = data.job
        }

        if (data.type) {
          params.type = data.type
        }

        return { url: 'sync', params }
      },
      providesTags: (results) => {
        if (!results) {
          return [{ type: 'Sync', id: 'LIST' }]
        }
        return []
      },
    }),
  }),
})

export const { useGetQuery } = syncApi

export default syncApi
